import { render, staticRenderFns } from "./RoleDetail.vue?vue&type=template&id=5e3d786a&scoped=true"
import script from "./role_detail.js?vue&type=script&lang=js&external"
export * from "./role_detail.js?vue&type=script&lang=js&external"
import style0 from "./role_detail.scss?vue&type=style&index=0&id=5e3d786a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3d786a",
  null
  
)

export default component.exports